if (!window.CollectionStickyButtonGroups) {
  window.CollectionStickyButtonGroups = {
    observers: [],

    disconnect() {
      this.observers.forEach((observer) => observer.disconnect());
      this.observers = [];
    },

    reset() {
      document.querySelectorAll('.collection-button-group-sticky').forEach((section) => {
        section.classList.remove(
          'collection-button-group-sticky',
          'collection-button-group-sticky--first',
          'sticky-element'
        );
        section.style.removeProperty('--sticky-offset');
        section.style.removeProperty('z-index');
      });

    },

    init() {
      this.disconnect();
      this.reset();

      const stickyButtonGroupPages = ['about-made-to-measure', 'ambassador-program'];
      const isStickyButtonGroupPage = stickyButtonGroupPages.some((templateSuffix) =>
        document.body.classList.contains(templateSuffix)
      );

      if (isStickyButtonGroupPage) {
        const buttonSection = document
          .querySelector('#MainContent > .shopify-section .button-list')
          ?.closest('.shopify-section');

        if (buttonSection) {
          buttonSection.classList.add(
            'collection-button-group-sticky',
            'collection-button-group-sticky--first',
            'sticky-element'
          );
          buttonSection.style.setProperty('--sticky-offset', '0px');
          buttonSection.style.setProperty('z-index', '10');

          if (document.body.classList.contains('ambassador-program')) {
            const anchorGap = 24;
            const anchorIds = ['club-veza-athlete-program', 'club-veza-creator-program'];

            const alignAnchorBelowButtonGroup = (target) => {
              if (!target) return;

              const buttonGroupBottom = buttonSection.getBoundingClientRect().bottom;
              const targetTop = target.getBoundingClientRect().top;
              window.scrollBy({
                top: targetTop - buttonGroupBottom - anchorGap,
                behavior: 'auto',
              });
            };

            document.querySelectorAll(anchorIds.map((id) => `a[href="#${id}"]`).join(',')).forEach((link) => {
              link.onclick = (event) => {
                if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

                const target = document.getElementById(link.hash.slice(1));
                if (!target) return;

                event.preventDefault();
                target.scrollIntoView({ behavior: 'auto', block: 'start' });
                window.history.pushState(null, '', link.hash);

                requestAnimationFrame(() => {
                  alignAnchorBelowButtonGroup(target);
                  requestAnimationFrame(() => alignAnchorBelowButtonGroup(target));
                });
              };
            });

            const hashTarget = document.getElementById(window.location.hash.slice(1));
            if (hashTarget && anchorIds.includes(hashTarget.id)) {
              requestAnimationFrame(() => {
                alignAnchorBelowButtonGroup(hashTarget);
                requestAnimationFrame(() => alignAnchorBelowButtonGroup(hashTarget));
              });
            }
          }
        }
      }

      document.querySelectorAll('#MainContent > .shopify-section .collection-horizontal-filters').forEach((filterBar) => {
        const collectionSection = filterBar.closest('.shopify-section');
        const stickySections = [];
        let buttonSectionCount = 0;
        let previousSection = collectionSection?.previousElementSibling;

        while (previousSection) {
          if (previousSection.querySelector('.button-list')) {
            stickySections.unshift(previousSection);
            buttonSectionCount += 1;
            previousSection = previousSection.previousElementSibling;
            continue;
          }

          if (buttonSectionCount === 0 && previousSection.querySelector('.section.no-empty')) {
            stickySections.unshift(previousSection);
            previousSection = previousSection.previousElementSibling;
            continue;
          }

          break;
        }

        if (!collectionSection || buttonSectionCount === 0) return;

        const updateOffsets = () => {
          let totalHeight = 0;

          stickySections.forEach((stickySection, index) => {
            stickySection.classList.add('collection-button-group-sticky', 'sticky-element');
            stickySection.classList.toggle('collection-button-group-sticky--first', index === 0);
            stickySection.style.setProperty('--sticky-offset', `${totalHeight}px`);
            stickySection.style.setProperty('z-index', `${10 + stickySections.length - index}`);
            totalHeight += Math.ceil(stickySection.getBoundingClientRect().height) - (index === 0 ? 1 : 0);
          });
        };

        updateOffsets();

        if (window.ResizeObserver) {
          const observer = new ResizeObserver(updateOffsets);
          stickySections.forEach((stickySection) => observer.observe(stickySection));
          this.observers.push(observer);
        }
      });
    },
  };

  document.addEventListener('DOMContentLoaded', () => window.CollectionStickyButtonGroups.init());

  if (window.Shopify?.designMode) {
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((eventName) => {
      document.addEventListener(eventName, () => requestAnimationFrame(() => window.CollectionStickyButtonGroups.init()));
    });
  }
}
